// @flow

import React from 'react';
import { Container } from '../grid';
import {
  ProgressRow as ProgressRowStyled,
  ProgressContainer,
} from './progressRow.styled';
import {
  CartSummary,
  CartSummaryContainer,
  Steps,
  StepsContainer,
} from './atoms';
import type { ProgressRowProps } from './types';

const ProgressRow = ({
  price,
  steps,
  className,
}: ProgressRowProps) => (
  <ProgressRowStyled sticky className={className}>
    <Container>
      <ProgressContainer>
        <StepsContainer>
          <Steps
            steps={steps}
          />
        </StepsContainer>
        <CartSummaryContainer>
          <CartSummary price={price} />
        </CartSummaryContainer>
      </ProgressContainer>
    </Container>
  </ProgressRowStyled>
);

export default ProgressRow;
